import React from 'react';
import { LayoutStandardPage } from '../layout/LayoutStandardPage';
import { PartialImpressum } from '../layout/Partial/PartialImpressum';

export const ImpressumPage = () => {
    return (
        <LayoutStandardPage component={PartialImpressum.toString()} />
    );
}; 